const multipleWhitespaceRegex = /\s+/;

export const obscureName = (name: string): string => {
  return name
    ?.trim()
    ?.split(multipleWhitespaceRegex)
    ?.filter(word => word.length > 0)
    ?.map(word => word[0] + '*'.repeat(word.length - 1))
    ?.join(' ');
};
